// extracted by mini-css-extract-plugin
export default {"btn":"credit-chat-btn_btn__D84R7","btnIcon":"credit-chat-btn_btnIcon__c3Cnl"};